import React, { CSSProperties, useEffect, useState } from 'react';
import { SYSTEM_VERSIONS } from '../../helpers/Systems';
import Button from '../../../components/CustomButtons/ButtonTS';

type AcknowledgeLogButtonProps = {
	ID: number;
	confirmed: string;
	confirmable: boolean;
	systemVersion: SYSTEM_VERSIONS;
	severity: string;
	confirmedLogFailed: boolean;
	confirmedLogSuccessfully: boolean;
	confirmNotification: (ID: number) => void;
};

const buttonStyle: CSSProperties = {
	textTransform: 'uppercase',
	margin: '15px',
};

const AcknowledgeLogButton = ({
	ID,
	confirmed,
	confirmable,
	systemVersion,
	severity,
	msgTemplateId,
	confirmedLogFailed,
	confirmedLogSuccessfully,
	confirmNotification,
}: AcknowledgeLogButtonProps) => {
	const skipButton = () => confirmed || severity === 'website' || !confirmable;
	const systemVersionW2 = () => systemVersion === SYSTEM_VERSIONS.W2.valueOf();
	const [isButtonDisabled, setIsButtonDisabled] = useState(false);

	useEffect(() => {
		if (confirmedLogFailed) {
			setIsButtonDisabled(false);
		}
	}, [confirmedLogFailed]);

	useEffect(() => {
		if (confirmedLogSuccessfully) {
			setIsButtonDisabled(true);
			setTimeout(() => {
                setIsButtonDisabled(false);
            }, 3000)
		}
	}, [confirmedLogSuccessfully]);

	const handleConfirm = () => {
		setIsButtonDisabled(true);
		confirmNotification(ID);
	};

	if (systemVersionW2()) {
		return <span style={{ color: '#ddd' }}>N/A for W2</span>;
	}

	if (skipButton()) {
		return <span style={{ color: '#ddd' }}>Confirmed</span>;
	}

	return (
		<Button
			size='sm'
			style={buttonStyle}
			color='info'
			onClick={handleConfirm}
			disabled={isButtonDisabled}
		>
			confirm
		</Button>
	);
};

export default AcknowledgeLogButton;
